import { apiClient } from '@features/shared/api/client'
import type {
  ChatFolderNameRequest,
  ChatFoldersResponse,
  ChatThreadsResponse,
  MoveChatThreadRequest,
} from './contracts'

export async function getChatFolders(): Promise<ChatFoldersResponse> {
  const { data } = await apiClient.get<ChatFoldersResponse>('/assistant/folders')
  return data
}

/** Every thread filed in the folder, most recently active first: unlike the
 * history list, not capped, so a filed chat never drops out of its folder. */
export async function getChatFolderThreads(folderId: string): Promise<ChatThreadsResponse> {
  const { data } = await apiClient.get<ChatThreadsResponse>(
    `/assistant/folders/${encodeURIComponent(folderId)}/threads`
  )
  return data
}

export async function createChatFolder(
  payload: ChatFolderNameRequest
): Promise<ChatFoldersResponse> {
  const { data } = await apiClient.post<ChatFoldersResponse>('/assistant/folders', payload)
  return data
}

export async function renameChatFolder(
  folderId: string,
  payload: ChatFolderNameRequest
): Promise<ChatFoldersResponse> {
  const { data } = await apiClient.patch<ChatFoldersResponse>(
    `/assistant/folders/${encodeURIComponent(folderId)}`,
    payload
  )
  return data
}

export async function deleteChatFolder(folderId: string): Promise<ChatFoldersResponse> {
  const { data } = await apiClient.delete<ChatFoldersResponse>(
    `/assistant/folders/${encodeURIComponent(folderId)}`
  )
  return data
}

export async function moveChatThread(
  threadId: string,
  payload: MoveChatThreadRequest
): Promise<ChatThreadsResponse> {
  const { data } = await apiClient.put<ChatThreadsResponse>(
    `/assistant/threads/${encodeURIComponent(threadId)}/folder`,
    payload
  )
  return data
}
